import { useEffect, useState } from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  position = "top-right",
  ...props
}) => {
  const { theme = "system" } = useTheme()
  const [compact, setCompact] = useState(() => typeof window !== "undefined" && !!window.matchMedia?.("(max-width: 1023px)").matches)
  useEffect(() => {
    const media = window.matchMedia("(max-width: 1023px)")
    const update = () => setCompact(media.matches)
    update()
    media.addEventListener("change", update)
    return () => media.removeEventListener("change", update)
  }, [])

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position={compact ? "bottom-right" : position}
      offset={{ top: 80 }}
      mobileOffset={{ left: 16, right: 16, bottom: "calc(16px + env(safe-area-inset-bottom))" }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
